var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

import * as cookie from "js-cookie";
import { FRONTEND_ROOT } from "../config/constants";

var _FRONTEND_ROOT$split = FRONTEND_ROOT.split("://"),
    _FRONTEND_ROOT$split2 = _slicedToArray(_FRONTEND_ROOT$split, 2),
    proto = _FRONTEND_ROOT$split2[0],
    domain = _FRONTEND_ROOT$split2[1];

domain = domain.split(":")[0];

export var getLocalItem = function getLocalItem(key) {
  return cookie.getJSON(key);
};

export var setLocalItem = function setLocalItem(key, value, params) {
  return cookie.set(key, value, _extends({
    domain: domain,
    secure: proto === "https"
  }, params));
};

export var removeLocalItem = function removeLocalItem(key, params) {
  return cookie.remove(key, _extends({ domain: domain }, params));
};


// WEBPACK FOOTER //
// ./src/utils/localdb.js